import store from '@/store'
import axios from 'axios'

store.subscribe((mutation)=>{
    // _m12tk10q === token
    // _d11ed20d === expirationDate
    switch (mutation.type) {
        case 'SET_TOKEN':
            if(mutation.payload){
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
                localStorage.setItem('_m12tk10q', mutation.payload)
            } else {
                axios.defaults.headers.common['Authorization'] = null
                localStorage.removeItem('_m12tk10q')
            }
        break;
    }
})

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // store.dispatch('setLoader', true)
    loadingText.set()
    return config;
}, function (error) {
    // Do something with request error
    // store.dispatch('setLoader', false)
    loadingText.return()
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // store.dispatch('setLoader', false)
    loadingText.return()
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // store.dispatch('setLoader', false)
    loadingText.return()
    return Promise.reject(error);
});